const config = {
    dev: {
        apiUrl: 'http://192.168.15.30:8080',
        tenantId: process.env.REACT_APP_TENANT_ID || 'vai_express',
    },
    production: {
        // Mesma origem: nginx do front faz proxy para pladitran-servidor na rede Docker
        apiUrl: '',
        tenantId: process.env.REACT_APP_TENANT_ID || 'vai_express',
    },
};

const env = process.env.NODE_ENV || 'development';

export default config[env] || config.dev;
